import type { GhostTag, SelectResultFn } from "../../types";
import TagListItem from "./TagListItem";

interface TagResultsProps {
  tags: GhostTag[];
  selectedResult: string | null;
  setSelectedResult: SelectResultFn;
}

export default function TagResults({
  tags,
  selectedResult,
  setSelectedResult,
}: TagResultsProps) {
  if (!tags?.length) {
    return null;
  }
  return (
    <div className="border-t border-gray-200 py-3 px-4 sm:px-7">
      <h1 className="uppercase text-xs text-neutral-400 font-semibold mb-1 tracking-wide">
        Tags
      </h1>
      {tags.map((tag) => (
        <TagListItem
          key={tag.name}
          tag={tag}
          selectedResult={selectedResult}
          setSelectedResult={setSelectedResult}
        />
      ))}
    </div>
  );
}
